<template>
    <v-dialog v-model="dlgMultInvoice" persistent width="1360" max-width="dlgMultInvoice">
        <v-card>
            <v-toolbar color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Invoice by Range
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table :headers="headers" :items="invoices" dense v-show="!print">
                    <template v-slot:item.Action="{item}">
                        <v-btn class="my-2 mr-2" icon color="primary" small @click="printInvoice(item)"><v-icon>mdi-printer</v-icon></v-btn>
                    </template>
                </v-data-table>

                <v-progress-linear v-model="progress" height="25" class="my-5" v-show="print">
                    <strong>{{ Math.ceil(progress) }}%</strong>
                </v-progress-linear>
                <v-row justify="end">
                    
                <v-btn class="my-2 mr-2" color="primary" v-show="!print" small @click="printInvoiceOneByOne">Print All</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    props: ['invoices', 'dlgMultInvoice'],
    data: function () {
        return {
            headers: [
                { text: 'InvId', value: 'InvId' },
                { text: 'Invoice Type', value: 'InvTypeName' },
                { text: 'Customer', value: 'Customer' },
                { text: 'OrderTotal', value: 'OrderTotal' },
                { text: 'FSCAmount', value: 'FSCAmount' },
                { text: 'HST', value: 'HST' },
                { text: 'TVQ', value: 'TVQ' },
                { text: 'SubTotal', value: 'SubTotal' },
                { text: 'Total', value: 'Total' },
                { text: 'Action', value: 'Action' },
            ],
            progress: 0,
            print: false,
        }
    },

    mounted() {
        console.log('here', this.invoices);
    },
    methods: {
        printInvoice: function(x){
            var str = this.$store;
            str.state.isLoading = true;
            const parms = {
                Id: x.CompanyID,
                InvId: x.InvId
            };
            axios
                .post('invoice/print/pdf', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', x.InvId + ' - ' + moment(x.InvDate).format('ll') + ".pdf");
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
        },
        printInvoiceOneByOne: async function () {
            this.print = true;
            this.progress = 0;
            var str = this.$store;
            const long = this.invoices.length;
            const porcent = 100 / long;
            for (const x of this.invoices) {
                const parms = {
                    Id: x.CompanyID,
                    InvId: x.InvId
                };
                await axios
                .post('invoice/print/pdf', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', x.InvId + ' - ' + moment(x.InvDate).format('ll') + ".pdf");
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    str.state.isLoading = false;
                });
                    this.progress = porcent + this.progress;

            }
            this.$emit('close');
        }
    }
}
</script>